// @flow

import React from 'react';
import { Translate } from 'react-redux-i18n';
import { kpiSelectorMapping } from '../geminiConst';

type Props = {
  closeModale: () => void,
  selectedKpi: string,
  selectedFilters: string[],
  setSelectedFilter: (string[]) => void,
}

function ChartKpiSelector({
  closeModale, selectedKpi, selectedFilters, setSelectedFilter,
}: Props) {
  const selectKpiFilter = (kpi: string) => {
    if (selectedFilters.filter(kpiSelected => kpiSelected === kpi).length > 0) {
      setSelectedFilter(selectedFilters.filter(kpiSelected => kpiSelected !== kpi));
    } else {
      setSelectedFilter([...selectedFilters, kpi]);
    }
  };

  const selectAllKpi = (event: Event) => {
    event.stopPropagation();
    if (areAllKpiSelected()) {
      setSelectedFilter([]);
    } else {
      setSelectedFilter([].concat(kpiSelectorMapping[selectedKpi].multipleSelect));
    }
  };

  const areAllKpiSelected = () => (
    selectedFilters.length
    === kpiSelectorMapping[selectedKpi].multipleSelect.length
  );

  return (
    <div className="kpi-selector">
      <div className="kpi-selector-header">
        Kpi
        <i className="fa fa-times" onClick={closeModale} />
      </div>
      <div className="kpi-checkbox-container">
        <button className="select-all" onClick={event => selectAllKpi(event)}>
          {
              areAllKpiSelected()
                ? <Translate value="GEMINI.UNSELECT_ALL" />
                : <Translate value="GEMINI.SELECT_ALL" />
            }

        </button>
        {
            kpiSelectorMapping[selectedKpi].multipleSelect.map(kpi => (
              <div
                className="kpi-checkbox"
                key={kpi}
                onClick={() => selectKpiFilter(kpi)}
              >
                <input
                  type="checkbox"
                  className="checkbox"
                  checked={selectedFilters.filter(kpiSelected => kpiSelected === kpi).length > 0}
                  onChange={() => selectKpiFilter(kpi)}
                />
                <label>
                  <Translate value={`GEMINI.KPI.${kpi}`} />
                </label>
              </div>
            ))
          }
      </div>
    </div>
  );
}

export default ChartKpiSelector;
